<template>
  <div class="home">
    <div>
      <div>
        <section>
          <div class="py-8 px-8">
            <div class="d-flex flex-wrap align-items-center justify-content-between">
              <div class="col-12 col-lg-auto mb-3 mb-lg-0">
                <div class="d-flex align-items-center">
                  <h4 class="mb-0 me-2">{{$t('projects')}}</h4>
                </div>
              </div>
              <div class="col-12 col-lg-auto d-flex align-items-center gap-2">
                <div class="input-group flex-grow-1" style="border-bottom: 1px solid #ddd;">
                  <input class="form-control border-0 search-input" autocomplete="off" type="text" v-model="keyword" :placeholder="$t('search')">
                </div>
                <button @click="showFilters = !showFilters" class="btn btn-outline-secondary d-md-none">
                  <AppIcon name="bi-funnel" class="bi bi-funnel" />
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>

      <section class="px-8">
        <!-- Mobile action buttons -->
        <div class="d-flex d-md-none gap-2 mb-3">
          <button v-if="helper.checkAccess('create_projects') > 0" @click="openCreateModal = true" class="btn btn-sm btn-success flex-grow-1">
            <PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" />
            <span>{{$t('project')}}</span>
          </button>
        </div>

        <!-- Filters section -->
        <div class="row align-items-end g-2 mb-4" :class="{'d-none d-md-flex': !showFilters}">
          <div class="col-12 col-md-3 col-lg-2">
            <label class="form-label small d-md-none mb-1">{{$t('status')}}</label>
            <select v-model="filters.status" class="form-select form-select-sm">
              <option value="">{{$t('all')}}</option>
              <option value="draft">{{$t('draft')}}</option>
              <option value="active">{{$t('active')}}</option>
              <option value="on_hold">{{$t('on_hold')}}</option>
              <option value="completed">{{$t('completed')}}</option>
              <option value="cancelled">{{$t('cancelled')}}</option>
            </select>
          </div>
          <div class="col-12 col-md-3 col-lg-2">
            <label class="form-label small d-md-none mb-1">{{$t('priority')}}</label>
            <select v-model="filters.priority" class="form-select form-select-sm">
              <option value="">{{$t('all')}}</option>
              <option value="low">{{$t('low')}}</option>
              <option value="medium">{{$t('medium')}}</option>
              <option value="high">{{$t('high')}}</option>
              <option value="urgent">{{$t('urgent')}}</option>
            </select>
          </div>
          <div class="col d-none d-md-block"></div>
          <div class="col-md-2 d-none d-md-block" v-if="helper.checkAccess('create_projects') > 0">
            <button @click="openCreateModal = true" class="btn btn-sm btn-success w-100">
              <PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" />
              <span>{{$t('project')}}</span>
            </button>
          </div>
        </div>
        <project-component :openCreateModal="openCreateModal" @createModalStatus="createModalStatus" :keyword="keyword" :filters="filters"></project-component>
      </section>
    </div>
  </div>
</template>

<script>
import ProjectComponent from '../../components/ProjectComponent.vue'
import helper from '../../helper'

export default {
  name: 'Project',
  persistedFilterState: { key: 'projects', fields: ['keyword', 'filters'] },
  components: {
    ProjectComponent,
  },
  data() {
    return {
      helper,
      keyword: '',
      openCreateModal: false,
      showFilters: false,
      filters: {
        status: '',
        priority: ''
      }
    }
  },
  mounted() {
    //check permissions
    if(helper.checkAccess('view_projects') == -1) return this.$router.push({path : '/'})
    if(helper.checkAccess('view_projects') == -2) return this.$router.push({path : '/subscribe'})

    window.mixpanel.track("project");
  },
  methods: {
    createModalStatus() {
      this.openCreateModal = false
    }
  }
}
</script>
